import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { EAppIcons } from 'src/app/classes/def/app/icons';
import { IGameItem } from 'src/app/classes/def/items/game-item';
import { Util } from 'src/app/classes/general/util';

@Component({
    selector: 'attribution-disp',
    templateUrl: './attribution-disp.component.html',
    styleUrls: ['./attribution-disp.component.scss'],
})

export class AttributionDispComponent implements OnInit, OnDestroy {

    @Input()
    item: IGameItem;

    appIcons = EAppIcons;
    withReference: boolean = false;
    withReferenceLink: boolean = false;
    withReferenceTag: boolean = false;
    referenceName: string = null;
    referenceLabel: string = "More info";

    constructor(

    ) {

    }

    ngOnInit() {
        if (this.item.wikiUrl) {
            this.withReference = true;
            this.referenceName = this.item.wikiName ? this.item.wikiName : "More info";
            if (this.item.wikiUrl.indexOf("<a href") !== -1) {
                this.withReferenceLink = false;
                this.withReferenceTag = true;
                this.referenceName = this.item.wikiUrl;
            } else {
                this.withReferenceLink = true;
            }
        }
    }

    ngOnDestroy() {

    }

    goToReference() {
        if (this.item.wikiUrl) {
            Util.openURL(this.item.wikiUrl);
        }
    }

}
